export enum createCompanyEmployeeFormFields {
  company_group = 'company_group',
  full_name_en = 'full_name_en',
  full_name_ar = 'full_name_ar',
  email = 'email',
  phone_number = 'phone_number',
  national_id = 'national_id',
  national_id_expiry = 'national_id_expiry',
  id_issue_date = 'id_issue_date',
  gender = 'gender',
  address = 'address',
  date_of_birth = 'date_of_birth',
  company_employee_marital_status = 'company_employee_marital_status',
  job_title = 'job_title',
  department = 'department',
  joining_date = 'joining_date',
  salary = 'salary',
  employee_contribution_amount = 'employee_contribution_amount',
  company_employee_status_id = 'company_employee_status_id',
  type = 'type',
  family_name_en = 'family_name_en',
  family_name_ar = 'family_name_ar',
  first_name_ar = 'first_name_ar',
  first_name_en = 'first_name_en',
  father_name_ar = 'father_name_ar',
  assurance_level = 'assurance_level',
  father_name_en = 'father_name_en',
  grand_father_name_ar = 'grand_father_name_ar',
  grand_father_name_en = 'grand_father_name_en',
  nationality_ar = 'nationality_ar',
  nationality_en = 'nationality_en',
  issue_location_ar = 'issue_location_ar',
  issue_location_en = 'issue_location_en',
  language = 'language',
  iqama_expiry_date = 'iqama_expiry_date',
  education_level = 'education_level',
  country = 'country',
  five_years_financial_sector = 'five_years_financial_sector',
  five_years_financial_sector_description = 'five_years_financial_sector_description',
  board_directors_member = 'board_directors_member',
  board_directors_member_description = 'board_directors_member_description',
  individual_with_high_profile_political_role = 'individual_with_high_profile_political_role',
  individual_with_high_profile_political_role_description = 'individual_with_high_profile_political_role_description',
  not_beneficial_owner = 'not_beneficial_owner',
  not_beneficial_owner_description = 'not_beneficial_owner_description',
}
